import Utils from "platform/util/Utils";

enum PaymentMethod {

    CreditCard = "credit-card",
    Paypal = "paypal",
    Neteller = "neteller",
    Trustly = "trustly",
    EasyEFT = "easyEFT",
    EcoPayz = "ecoPayz",
    Zimpler = "zimpler",
    Klarna = "klarna",
    Skrill = "skrill",
    Sofort = "sofort",
    AstroPay = "astroPay",
    EcoVoucher = "ecoVoucher",
    GlobePay = "globePay",
    Psc = "psc",
    SafetyPay = "safetyPay",
    TapPayments = "tapPayments",
    WireTransfer = "wire-transfer",
}

namespace PaymentMethod {

    export function deserialize(v: string): PaymentMethod {
        if (Utils.isNotEmpty(v)) {
            const keys: string[] = Object.keys(PaymentMethod);
            for (let i = 0; i < keys.length; i++) {
                if (PaymentMethod[keys[i]] === v) {
                    return v as PaymentMethod;
                }
            }
        }
        return null;
    }
}

export {
    PaymentMethod
};
